/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2024 Glowing Blue AG.
 * Authors: Davide Iadeluca.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';
export default class GlobalStats extends Model {
  users() {
    return Model.attribute('users').call(this);
  }
  discussions() {
    return Model.attribute('discussions').call(this);
  }
  currentlyOnline() {
    return Model.attribute('currentlyOnline').call(this);
  }
  apiEndpoint() {
    return '/global_stats';
  }
}
flarum.reg.add('glowingblue-gamilytics', 'common/models/GlobalStats', GlobalStats);